import { Button } from "@mui/material"
import { WithRecord, useNotify, useRecordContext, useTranslate } from "react-admin"
import { useMutation } from "react-query";
import { apiService } from "../../apiService";
import fileDownload from "js-file-download";
import { InvoiceReadModel } from "../../GeneratedClients/FreeBillApi";

const DownloadPdfButton = () => {

  const translate = useTranslate()
  const notify = useNotify()
  const record = useRecordContext()
  const { mutate, isLoading } = useMutation((id: string) => 
    apiService.InvoicesApi.downloadPdf({id: id}, {responseType: 'blob'}),
    {
      onSuccess: (data) => {
        var pdfFile: any = data.data
        fileDownload(pdfFile, `E-Rechnung ${record?.invoiceNumber}-ZUGFeRD.pdf`)
        notify(translate("resources.invoices.notifications.downloaded"))
      },
      onError: (error: any) => {
        notify(error, {type: error})
      }
    }   
  )
  const downloadPdf = (id?: string) => { 
    if(id) mutate(id)
  }

  return (
    <WithRecord render={(invoice: InvoiceReadModel) => 
      <Button
        disabled={isLoading} 
        size='small' 
        onClick={() => downloadPdf(invoice.id)} 
      >
        {translate("resources.invoices.actions.download")}
      </Button>
    } />
  )
}

export default DownloadPdfButton